module.exports = __webpack_public_path__ + "static/media/empty_rsvp2x.2ca5e8fa.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/empty_rsvp2x.png
 ** module id = 1958
 ** module chunks = 50
 **/